import type { FilterCategoryGroupIds } from './Filters.types'

interface FilterCategoryMapping {
  key: FilterCategoryGroupIds
  groupName: string
  translationKey: string
  filterIds: string[]
}

export const CDCMappings: FilterCategoryMapping[] = [
  {
    key: 'salesAndPromotions',
    groupName: 'Sales and promotions',
    translationKey: 'filters.offers',
    filterIds: [
      'ent_3nightsfor2',
      'ent_4nightsfor3',
      'ent_dogsgofree',
      'ent_pricedrop',
    ],
  },
  {
    key: 'stayTypeAndCollections',
    groupName: 'Stay type and collections',
    translationKey: 'filters.startypes-collections',
    filterIds: [
      'ent_luxurycollection',
      'ent_romanticgetaways',
      'ent_trulyunique',
      'ent_ecostays',
      'ent_glampingcollection',
      'ent_grouped',
      'ent_christmasdecor',
      'ent_choice',
      'ent_newlylistedproperties',
      'ent_bookbefore',
      'ent_lodge',
      'ent_handpickedbyjames',
      'ent_rareavailability',
    ],
  },
  {
    key: 'locationAndSurroundings',
    groupName: 'Location and surroundings',
    translationKey: 'filters.locations-surrounding',
    filterIds: [
      'ent_rural',
      'ent_coastalwithin1mile',
      'ent_coastalwithin3miles',
      'ent_coastalwithin5miles',
      'ent_seaview',
      'ent_beachnearby',
      'ent_waterside',
      'ent_golf',
      'ent_fishing',
      'ent_pub',
      'ent_train',
      'ent_pubwalk',
    ],
  },
  {
    key: 'facilitiesAndAmenities',
    groupName: 'Facilities and amenities',
    translationKey: 'filters.facilities-amenities',
    filterIds: [
      'ent_wifiac',
      'ent_parkingonsite',
      'ent_evchargingpoint',
      'ent_washingmachine',
      'ent_dishwasher',
      'ent_openfirewoodburningstove',
      'ent_gardenorpatio',
      'ent_enclosedgardenpatio',
      'ent_barbecue',
      'ent_decking',
      'ent_bicyclestore',
      'ent_bicyclesavailable',
    ],
  },
  {
    key: 'wellnessAndLeisure',
    groupName: 'Wellness and leisure facilities',
    translationKey: 'filters.leisure-wellness',
    filterIds: [
      'ent_swimmingpool',
      'ent_hottubprivate',
      'ent_sauna',
      'ent_steamroom',
      'ent_childplay',
      'ent_familygames',
    ],
  },
  {
    key: 'accessibilityAndLayout',
    groupName: 'Accessibility and layout',
    translationKey: 'filters.accessibility',
    filterIds: [
      'ent_groundfloorfacil',
      'ent_ensuite',
      'ent_wheelchairaccessible',
    ],
  },
  {
    key: 'pets',
    groupName: 'Pets',
    translationKey: 'filters.pets',
    filterIds: [
      'ent_petsallowed',
      'ent_petsfree',
      'ent_petsnotaccepted',
      'ent_morethandogfriendly',
    ],
  },
  {
    key: 'familyAndBaby',
    groupName: 'Family and baby',
    translationKey: 'filters.family',
    filterIds: [
      'ent_cot',
      'ent_highchair',
      'ent_babyandtoddlerfriendly',
      'ent_childplay',
      'ent_familygames',
    ],
  },
]

export const HOSMappings: FilterCategoryMapping[] = [
  {
    key: 'salesAndPromotions',
    groupName: 'Sales and offers',
    translationKey: 'filters.offers',
    filterIds: [
      'ent_3nightsfor2',
      'ent_4nightsfor3',
      'ent_dogsgofree',
      'ent_pricedrop',
      'ent_offersendingsoon',
    ],
  },
  {
    key: 'stayTypeAndCollections',
    groupName: 'Stay type and collections',
    translationKey: 'filters.startypes-collections',
    filterIds: [
      'ent_luxurycollection',
      'ent_hosautograph',
      'ent_hosbouja',
      'ent_hoswanderwood',
      'ent_hosgoactive',
      'ent_hosgoactiveplus',
      'ent_hosautographplus',
      'ent_glampingcollection',
      'ent_diamondawardwinners',
      'ent_hosevermore',
      'ent_hosmagnificent',
      'ent_watersidebreaks',
      'ent_hostailormade',
      'ent_hosdaisydoor',
      'ent_hosrelaxandexplore',
      'ent_hoslodgeescape',
      'ent_trulyunique',
      'ent_bestsellers',
      'ent_newlylistedproperties',
      'ent_newparkfor2025',
      'ent_handpickedbyjames',
      'ent_rareavailability',
    ],
  },
  {
    key: 'locationAndSurroundings',
    groupName: 'Location and surroundings',
    translationKey: 'filters.locations-surrounding',
    filterIds: ['ent_beachnearby', 'ent_seaview', 'ent_golf', 'ent_fishing'],
  },
  {
    key: 'facilitiesAndAmenities',
    groupName: 'Facilities and amenities',
    translationKey: 'filters.facilities-amenities',
    filterIds: [
      'ent_wifiac',
      'ent_parkingonsite',
      'ent_evchargingpoint',
      'ent_washingmachine',
      'ent_dishwasher',
      'ent_openfirewoodburningstove',
      'ent_barbecue',
      'ent_decking',
      'ent_golfonsite',
      'ent_bicyclesavailable',
      'ent_bicyclestore',
    ],
  },
  {
    key: 'wellnessAndLeisure',
    groupName: 'Wellness and leisure facilities',
    translationKey: 'filters.leisure-wellness',
    filterIds: [
      'ent_hottubprivate',
      'ent_swimmingpool',
      'ent_sauna',
      'ent_spaandbeauty',
      'ent_childplay',
      'ent_steamroom',
      'ent_familygames',
      'ent_familyentertainment',
      'ent_sportsbar',
    ],
  },
  {
    key: 'accessibilityAndLayout',
    groupName: 'Accessibility and layout',
    translationKey: 'filters.accessibility',
    filterIds: ['ent_wheelchairaccessible'],
  },
  {
    key: 'pets',
    groupName: 'Pets',
    translationKey: 'filters.pets',
    filterIds: [
      'ent_petsallowed',
      'ent_petsfree',
      'ent_petsnotaccepted',
      'ent_petsfreeofcharge',
    ],
  },
  {
    key: 'familyAndBaby',
    groupName: 'Family and baby',
    translationKey: 'filters.family',
    filterIds: [
      'ent_childplay',
      'ent_cot',
      'ent_highchair',
      'ent_kidsclub',
      'ent_hosfamilyfunplus',
      'ent_familygames',
      'ent_familyentertainment',
      'ent_hosfamilyfun',
    ],
  },
]

export const NOVMappings: FilterCategoryMapping[] = [
  {
    key: 'salesAndPromotions',
    groupName: 'Sales and offers',
    translationKey: 'filters.offers',
    filterIds: [
      'ent_petsfree',
      'ent_3nightsfor2',
      'ent_4nightsfor3',
      'ent_dogsgofree',
      'ent_pricedrop',
    ],
  },
  {
    key: 'propertyType',
    groupName: 'Property type',
    translationKey: 'filters.accomodation-type',
    filterIds: [
      'ent_apartment',
      'ent_holidayhome',
      'ent_holidayparkeu',
      'ent_houseboat',
      'ent_glampingcollection',
      'ent_grouped',
    ],
  },
  {
    key: 'stayTypeAndCollections',
    groupName: 'Stay type and collections',
    translationKey: 'filters.startypes-collections',
    filterIds: [
      'ent_luxurycollection',
      'ent_romanticgetaways',
      'ent_ecostays',
      'ent_choice',
      'ent_newlylistedproperties',
      'ent_bookbefore',
      'ent_christmasdecor',
      'ent_canolabel',
      'ent_shortbreak',
      'ent_flexiblearrival',
      'ent_energysavingprop',
      'ent_rareavailability',
    ],
  },
  {
    key: 'locationAndSurroundings',
    groupName: 'Location and surroundings',
    translationKey: 'filters.locations-surrounding',
    filterIds: [
      'ent_beachnearby',
      'ent_beachfront',
      'ent_coastalwithin1mile',
      'ent_coastalwithin3miles',
      'ent_coastalwithin5miles',
      'ent_seaview',
      'ent_scenicviews',
      'ent_rural',
      'ent_waterside',
      'ent_train',
      'ent_pub',
      'ent_golf',
      'ent_fishing',
      'ent_boatavailable',
    ],
  },
  {
    key: 'facilitiesAndAmenities',
    groupName: 'Facilities and amenities',
    translationKey: 'filters.facilities-amenities',
    filterIds: [
      'ent_wifiac',
      'ent_parkingonsite',
      'ent_aircon',
      'ent_dishwasher',
      'ent_washingmachine',
      'ent_evchargingpoint',
      'ent_openfirewoodburningstove',
      'ent_bicyclestore',
      'ent_bicyclesavailable',
      'ent_allinclusive',
      'ent_gardenorpatio',
      'ent_enclosedgardenpatio',
      'ent_decking',
      'ent_barbecue',
    ],
  },
  {
    key: 'wellnessAndLeisure',
    groupName: 'Leisure and wellness',
    translationKey: 'filters.leisure-wellness',
    filterIds: [
      'ent_swimmingpool',
      'ent_hottubprivate',
      'ent_hottubspabathnov',
      'ent_sauna',
      'ent_steamroom',
      'ent_wellness',
      'ent_freeentrywaterpark',
    ],
  },
  {
    key: 'accessibilityAndLayout',
    groupName: 'Accessibility and layout',
    translationKey: 'filters.accessibility',
    filterIds: [
      'ent_wheelchairaccessible',
      'ent_groundfloorfacil',
      'ent_ensuite',
    ],
  },
  {
    key: 'familyAndBaby',
    groupName: 'Family and baby',
    translationKey: 'filters.family',
    filterIds: [
      'ent_babyandtoddlerfriendly',
      'ent_cot',
      'ent_highchair',
      'ent_familygames',
      'ent_childplay',
    ],
  },
  {
    key: 'pets',
    groupName: 'Pets',
    translationKey: 'filters.pets',
    filterIds: [
      'ent_petsallowed',
      'ent_petsfree',
      'ent_petsnotaccepted',
      'ent_morethandogfriendly',
    ],
  },
]

export const CDCUsageMap = [
  'popularFeatures',
  'bedrooms',
  'bathrooms',
  'facilitiesAndAmenities',
  'price',
  'locationAndSurroundings',
  'popularDestinations',
  'starRating',
  'salesAndPromotions',
  'pets',
  'accessibilityAndLayout',
  'customerReviewScore',
  'familyAndBaby',
  'stayTypeAndCollections',
  'wellnessAndLeisure',
]

export const NOVUsageMap = [
  'popularFeatures',
  'bedrooms',
  'bathrooms',
  'price',
  'facilitiesAndAmenities',
  'locationAndSurroundings',
  'starRating',
  'salesAndPromotions',
  'customerReviewScore',
  'wellnessAndLeisure',
  'propertyType',
  'pets',
  'familyAndBaby',
  'stayTypeAndCollections',
  'accessibilityAndLayout',
]

export const HOSUsageMap = [
  'popularFeatures',
  'bedrooms',
  'bathrooms',
  'popularDestinations',
  'facilitiesAndAmenities',
  'locationAndSurroundings',
  'salesAndPromotions',
  'price',
  'familyAndBaby',
  'wellnessAndLeisure',
  'customerReviewScore',
  'stayTypeAndCollections',
  'accessibilityAndLayout',
  'pets',
]

export const FilterAccordionOrderByBrand: Record<string, string[]> = {
  'cottages.com': CDCUsageMap,
  hoseasons: HOSUsageMap,
  novasol: NOVUsageMap,
  fincallorca: NOVUsageMap,
  jamesVillas: NOVUsageMap,
}
